import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class AuthService {
  constructor(
    private router: Router,
    private http: HttpClient
  ) {}

  login() {
    this.router.navigate(['/']).then();
  }

  logout() {
    this.http.get(environment.API_PATH + 'auth/logout', {withCredentials: true}).subscribe(
      () => { this.clearAndRedirect(); },
      () => { this.clearAndRedirect(); }
    );
  }

  private clearAndRedirect() {
    localStorage.clear();
    sessionStorage.clear();
    document.cookie.split(';').forEach(c => {
      const name = c.split('=')[0].trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    });
    window.location.href = '/auth/login';
  }

}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/auth/auth.service.ts